<template>
      <b-nav-item-dropdown right no-caret class="account-dropdown">
        <template slot="button-content">
          <a class="nav-link header-item mr-2">
            {{globals.username}}
            <icon icon="chevron-down"></icon>
          </a>
        </template>
        <b-dropdown-item><a target="_blank" href="/">{{$t('OPENSITEINNEWWINDOW')}}</a></b-dropdown-item>
        <b-dropdown-item @click="showChangePassword = true"><a>{{$t('CHANGEPASSWORD')}}</a></b-dropdown-item>
        <b-dropdown-item v-on:click.prevent="logout"><a href="">{{$t('LOGOUT')}}</a></b-dropdown-item>

        <ChangePasswordModal :show="showChangePassword" @close="showChangePassword = false" />
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ChangePasswordModal from './ChangePasswordModal.vue'

export default
{
  name: 'header-dropdown-accnt',
  components:
  {
    ChangePasswordModal,
  },
  data()
  {
    return {
      showChangePassword: false,
    };
  },
  methods:
  {
    ...mapActions([
      'logout'
    ])
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
